export const toCamelCase = (str: string) => {
  const tempStr = str.split(" ");
  return tempStr.map((item) => item[0].toUpperCase() + item.slice(1)).join(" ");
};
